/**
 * Leave types stored on attendance records / dashboard documents.
 * Shared domain values — not Real-Time UI status codes.
 */
export const ATTENDANCE_LEAVE_TYPE = {
  UNJUSTIFIED: 'unjustified_absence',
  JUSTIFIED: 'justified_absence',
  NONE: '',
} as const;

export type AttendanceLeaveType =
  (typeof ATTENDANCE_LEAVE_TYPE)[keyof typeof ATTENDANCE_LEAVE_TYPE];

/** Leave types that count as an absence for status / KPI logic. */
export const ATTENDANCE_ABSENCE_LEAVE_TYPES = [
  ATTENDANCE_LEAVE_TYPE.JUSTIFIED,
  ATTENDANCE_LEAVE_TYPE.UNJUSTIFIED,
] as const;
